module.exports = __webpack_public_path__ + "static/media/text-align-left-white.007fc3e6.svg";